import { apiClient } from "./client";

export const getVendors = ({ page = 1, limit = 10, search = "" } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });

  if (search.trim()) {
    query.set("search", search.trim());
  }

  return apiClient.get(`/admin/vendors?${query.toString()}`);
};

export const inviteVendor = ({ email }) => {
  return apiClient.post("/admin/invite-vendor", { email });
};

export const resendVendorInvite = (inviteId) => {
  return apiClient.post(`/admin/vendor-invitations/${inviteId}/resend`);
};

export const deleteVendorInvite = (inviteId) => {
  return apiClient.delete(`/admin/vendor-invitations/${inviteId}`);
};

export const deleteVendor = (vendorId) => {
  return apiClient.delete(`/admin/vendors/${vendorId}`);
};
